export default {
  onlineCustomers: 'Online customers',
  noCustomersOnlineMessage: 'No customers connected right now.',
  reconnecting: 'Reconnecting…',
  connectionLost: 'Connection lost',
  refreshPage: 'Refresh page',
}
